









































import { defineComponent, onMounted } from "@vue/composition-api";
import { useMachine } from "@xstate/vue";
import Store from "@/store";

import { AuthenticationApi } from "@/api";
import { AuthState } from "@/store/modules/auth/types";
import LoginWithTokenMachine from "./LoginWithTokenMachine";

const Component = defineComponent({
  name: "LoginWithToken",
  setup(props, vm) {
    const { state, send, service } = useMachine(LoginWithTokenMachine);
    const api = new AuthenticationApi();

    async function logInWithToken(token: string) {
      try {
        const { data } = await api.authenticationLoginWithToken({
          loginToken: token,
        });
        const authState: AuthState = {
          user: {
            email: "",
          },
          authorization: data,
        };
        Store.dispatch("Auth/logIn", authState).then(() => {
          setTimeout(() => {
            // Store.dispatch("setRootRegion", null);
            // Store.dispatch("User/reset");
            // Remove cachebuster querystring from browser url.
            window.history.replaceState({}, document.title, window.location.origin + window.location.pathname + '#')
            vm.root.$router.push({ name: "dashboard" });
          }, 3000);
        });
      } catch (err) {
        service.send("REJECT");
      }
    }

    onMounted(() => {
      const tokenParam = vm.root.$route.params.token;
      if (!tokenParam) {
        service.send("ERROR");
      }

      service.send("LOGIN");

      service.subscribe((s) => {
        if (s.matches("loading")) {
          logInWithToken(tokenParam);
        }
      });
    });

    return {
      service,
      send,
      state,
    };
  },
});

export default Component;
